// extracted by mini-css-extract-plugin
module.exports = {"container":"UserModale_container__1FjsD","row":"UserModale_row__CYspD","col":"UserModale_col__2I8h2","user":"UserModale_user__63yWz","delete":"UserModale_delete__2lY79"};